import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { statusColor } from "./constants";
import { toast } from "sonner";

export function OrdersTab({ orders, reload }) {
  const updateOrderStatus = async (oid, status) => {
    try {
      await api.put(`/admin/orders/${oid}/status`, { status });
      toast.success("تم تحديث الحالة");
      await reload();
    } catch (e) { toast.error("فشل"); }
  };

  return (
    <div className="space-y-3">
      {orders.length === 0 ? (
        <div className="jh-card p-10 text-center text-[#6B6B6B]">لا توجد طلبات بعد</div>
      ) : orders.map((o) => (
        <div key={o.order_id} className="jh-card p-4 flex items-center gap-4 flex-wrap" data-testid={`admin-order-${o.order_id}`}>
          <div className="flex-1 min-w-[200px]">
            <p className="text-xs text-[#6B6B6B]">#{o.order_id.slice(-6).toUpperCase()}</p>
            <h3 className="font-bold text-[#1A1A1A]">{o.restaurant_name_ar}</h3>
            <p className="text-xs text-[#6B6B6B] mt-1">
              {o.items.length} عنصر · {o.payment_method === "cash" ? "كاش" : "بطاقة"}
              {" · "}{new Date(o.created_at).toLocaleDateString("ar-SA")}
            </p>
          </div>
          <div className="text-end">
            <p className="font-bold text-[#E05D3A]">{o.total.toFixed(2)} SAR</p>
            <Badge className={`${statusColor[o.status]} mt-1`}>{o.status}</Badge>
          </div>
          <Select value={o.status} onValueChange={(v) => updateOrderStatus(o.order_id, v)}>
            <SelectTrigger className="w-[160px]" data-testid={`admin-order-status-${o.order_id}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="placed">تم الطلب</SelectItem>
              <SelectItem value="preparing">قيد التحضير</SelectItem>
              <SelectItem value="on_the_way">في الطريق</SelectItem>
              <SelectItem value="delivered">تم التوصيل</SelectItem>
              <SelectItem value="cancelled">ملغى</SelectItem>
            </SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
}
